import React, { useState } from "react";
import DatatableComponent from "helpers/DatatableComponent";
import BasicMenu from "helpers/menu";
import { useHistory } from "react-router";
import moment from "moment";
import { Chip, Tooltip } from "@mui/material";
import { Key, KeyOffSharp } from "@mui/icons-material";
import FormDialog from "helpers/FormDialog";
import { mapDispatchToProps } from "store/helpers/mapDispatch";
import { mapStateToProps } from "store/helpers/mapState";
import { connect } from "react-redux";

const SystemUsers = ({ PutAction, loggedUser, location, url }) => {
  const history = useHistory();
  const [list, setList] = useState([]);
  const [openRole, setOpenRole] = React.useState(false);
  const [count, setCount] = React.useState(0);
  const [id, setId] = React.useState();
  const [value, setValue] = React.useState({});
  const [openAddUser, setOpenAddUser] = React.useState(0);

  const structure = location?.state?.structure;
  const urlString = url ?? location?.state?.url;
  const isSuperAdmin = loggedUser?.role === "superAdmin";

  const setValue0 = (name, val) => {
    if (!name) {
      return null;
    }

    setValue((v) => {
      v[name] = val;
      return { ...v };
    });
  };

  const onSuccess = () => setCount((v) => v + 1);

  const handleChange = async (changeData) => {
    const resp = await PutAction(
      `/api/structure/user/update/${id}`,
      changeData
    );
    if (resp.status) {
      setCount(count + 1);
      setOpenRole(false);
    }
  };

  const columns = [
    {
      name: "names",
      label: "Names",
    },
    {
      name: "email",
      label: "Email",
    },
    {
      name: "structureName",
      label: "Structure",
    },

    {
      name: "lastLogin",
      label: "Last Login",
      options: {
        filter: false,
        sort: true,
        customBodyRender: (v) => {
          if (!v) {
            return "";
          }
          const diff = moment(new Date()).diff(v, "day");
          if (diff <= 2) {
            return (
              <Tooltip
                componentsProps={{
                  tooltip: {
                    sx: {
                      backgroundColor: "white",
                      boxShadow:
                        "3px 4px 6px rgba(0, 0, 0, 0.1), 2px 2px 4px rgba(0, 0, 0, 0.06)",
                      color: "black",
                    },
                  },
                }}
                title={moment(v).format("YYYY-MMM-DD hh:mm:ss")}
              >
                <Chip
                  size={"small"}
                  color={"warning"}
                  label={moment(v).fromNow()}
                />
              </Tooltip>
            );
          } else {
            return (
              <Tooltip
                componentsProps={{
                  tooltip: {
                    sx: {
                      backgroundColor: "white",
                      boxShadow:
                        "3px 4px 6px rgba(0, 0, 0, 0.1), 2px 2px 4px rgba(0, 0, 0, 0.06)",
                      color: "black",
                    },
                  },
                }}
                title={moment(v).format("YYYY-MMM-DD hh:mm:ss")}
              >
                <Chip size={"small"} label={moment(v).fromNow()} />
              </Tooltip>
            );
          }
        },
      },
    },
    {
      name: "id",
      label: "System Role",
      options: {
        filter: false,
        sort: false,
        customBodyRender: (v) => {
          const user = list?.find((user) => user?.id === v);
          const canEdit =
            openRole && id === user?.id && user?.role !== "superAdmin";

          return canEdit ? (
            <select
              value={user?.role}
              className="form-select px-3 py-3 border-0 placeholder-blueGray-300 text-blueGray-600 bg-white rounded text-sm shadow focus:outline-none focus:ring w-full ease-linear transition-all duration-150"
              onChange={(e) => {
                handleChange({ id: user?.id, role: e.target.value });
              }}
            >
              {["user", "admin"]?.map((item) => (
                <option value={item}>{item}</option>
              ))}
            </select>
          ) : (
            user?.role
          );
        },
      },
    },
    {
      name: "id",
      label: "Action",
      options: {
        filter: false,
        sort: false,
        customBodyRender: (v) => {
          const user = list?.find((user) => user?.id === v);

          return (
            <BasicMenu
              // detailsName={"Permissions"}
              onEdit={isSuperAdmin?() => {
                setOpenAddUser(2);
                setId(structure?.id);
                setValue0("lastName", user?.lastName);
                setValue0("firstName", user?.firstName);
                setValue0("role", user?.role);
                setValue0("email", user?.email);
                setValue0("id", user?.id);

              }:null}
              extra={ !isSuperAdmin?[
                {
                  label: "Change Role",
                  onClick: () => {
                    setOpenRole(true);
                    setId(v);
                  },
                  icon: <KeyOffSharp />,
                },
                {
                  label: "Permissions",
                  onClick: () => {
                    history.push(`/admin/permission`, { userId: v });
                  },
                  icon: <Key />,
                },
              ]:null}
            />
          )
        },
      },
    },
  ];

  return (
    <div className="w-full mb-12 px-4">
      <FormDialog
        maxWidth={"md"}
        col={6}
        open={openAddUser > 0}
        onSuccess={() => {
          onSuccess();
          // onLoad();
        }}
        setOpen={setOpenAddUser}
        url={`/api/structure/user/create/${structure?.id}`}
        title={`Add Admin User`}
        fields={[
          {
            name: "firstName",
            label: "First Name",
            value: value["firstName"],
            required: true,
            col: 12,
            setValue: (val) => setValue0("firstName", val),
          },
          {
            name: "lastName",
            label: "Last Name",
            value: value["lastName"],
            required: true,
            col: 12,
            setValue: (val) => setValue0("lastName", val),
          },
          {
            name: "email",
            label: "Email",
            value: value["email"],
            required: true,
            col: 12,
            setValue: (val) => setValue0("email", val),
          },
          {
            name: "structure",
            label: "Structure",
            value: structure?.name,
            disabled: true,
            col: 12,
            setValue: (val) => setValue0("structure", val),
          },
          {
            name: "role",
            label: "Role",
            value: "admin",
            disabled: true,
            col: 12,
          },
          {
            name: "id",
            label: "id",
            value: value["id"],
            hidden: true,
            col: 12,
          },
        ]}
      />
      
      <DatatableComponent
        processData={(data) => {
          setList(data.data);
          return data;
        }}
        onAddNew={() => {
          setOpenAddUser(1);
        }}
        elevation={0}
        viewColumns={false}
        searchfield={true}
        search={false}
        hideToolbar={false}
        columns={columns}
        url={`${urlString}?count=${count}`}
        title={
          <div className="flex flex-col md:flex-row gap-2 ">
            <div className="md:w-full w-1/6 mb-2 xl:mb-0 "></div>
          </div>
        }
      />
    </div>
  );
};
export default connect(mapStateToProps, mapDispatchToProps)(SystemUsers);

// export default SystemUsers;
